import React from "react";
import Layout from "../Layout/Layout";

const TripOut = () => {
  return <Layout></Layout>;
};

export default TripOut;
